import {
  kPharmaciesFirestoreKey,
  kPharmaciesFirestoreKey as root,
} from "../constants/keys";
import {
  doc,
  collection,
  limit,
  getDocs,
  orderBy,
  query,
  startAfter,
  where,
  updateDoc,
  getDoc,
} from "@firebase/firestore";
import { db } from "../database";
import { createToast, NotificationBadge } from "@kiwicom/orbit-components";

const VerificationStatus = {
  approved: "approved",
  declined: "declined",
  review: "review",
};

Object.freeze(VerificationStatus);

export const fetchPharmacies = async (lastVisible) => {
  if (lastVisible === undefined)
    return Promise.reject("there are no pharmacies left to be approved");

  const ordersQuery = query(
    collection(db, root),
    orderBy("name"),
    where("verified", "==", VerificationStatus.review),
    startAfter(lastVisible),
    limit(5)
  );

  try {
    const querySnapshot = await getDocs(ordersQuery);
    console.table(querySnapshot.docs);
    return querySnapshot.docs;
  } catch (error) {
    console.log(error);
    createToast("Something went wrong while fetching pharmacies", {
      icon: <NotificationBadge />,
    });
    return Promise.reject("Something went wrong", error);
  }
};

export const approvePharmacy = async (pharmacyId) => {
  const docRef = doc(db, root, pharmacyId);

  try {
    await updateDoc(docRef, {
      verified: VerificationStatus.approved,
    });

    console.log("Pharmacy got approved");

    return true;
  } catch (error) {
    console.log(error);
    return Promise.reject("Something went wrong", error);
  }
};

export const rejectPharmacy = async (pharmacyId, comments) => {
  const pharmacyRef = doc(db, root, pharmacyId);

  try {
    await updateDoc(pharmacyRef, {
      verified: VerificationStatus.declined,
      "profile.comments": comments,
    });

    console.log("Pharmacy approval declined");

    return true;
  } catch (error) {
    console.log(error);
    return Promise.reject("Something went wrong", error);
  }
};
export const fetchPharmacyDetails = async (pharmacyId) => {
  try {
    const pharmacyRef = doc(db, kPharmaciesFirestoreKey, pharmacyId);
    const pharmacyDoc = await getDoc(pharmacyRef);
    if (pharmacyDoc.exists()) {
      console.log("Pharmacy details fetched");
      return pharmacyDoc;
    }
  } catch (error) {
    console.log(error);
    return Promise.reject("Something went wrong", error);
  }
};
